<atx-date-picker-navigation
  (next)="nextYear()"
  (previous)="previousYear()"
  (titleClick)="toggleYearSelector()"
>
  <span class="font-weight-cold">{{ currentYear$ | async }}</span>
</atx-date-picker-navigation>

<ng-container *ngrxLet="showPeriods$ as showPeriods">
  @if (!showPeriods) {
  <div class="period-selector">
    @for (year of years; track year) {
    <button
      class="btn btn-light"
      (click)="selectYear(year); toggleYearSelector()"
    >
      {{ year }}
    </button>
    }
  </div>
  } @if (showPeriods) {
  <span
    class="period-title"
    i18n="
      Datepicker|Interval period selector title@@intervalPeriodSelectorTitle"
  >
    Select a Fiscal Period
  </span>
  <div class="period-selector">
    @for (period of validPeriods$ | async; track period) {
    <button
      class="btn btn-light"
      [atxTooltip]="
        (period.interval.s | date: 'mediumDate') +
        ' - ' +
        (period.interval.e | date: 'mediumDate')
      "
      tooltipPlacement="top"
      [disabled]="!period.enabled"
      (click)="dateSelected(period.interval)"
    >
      {{ period.name }}
    </button>
    }
  </div>
  }
</ng-container>
